import React, { useState, useEffect } from 'react'
import {
  Panel,
  Form,
  Button,
  Radio,
  RadioGroup,
  Row,
  Col,
  Message,
  ControlLabel,
  Table,
} from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import CustomIconMessageInfo from '../CustomIconMessageInfo'
import { startLoading, doneLoading } from '../../utils/loading'
import InputForm from '../../components/forms/input/InputForm'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { useParams, useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import {
  isRequired,
  isValidators,
  requiredFiled,
  getRequiredData,
} from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import classNames from 'classnames'
import NumberFormat from 'react-number-format'
import { budgetFormat } from '../../utils/formatterUtil'
import AttachFilesForm from '../attachfiles/AttachFilesForm'
import AttachFilesView from '../attachfiles/AttachFilesView'
import { isEmpty } from 'lodash-es'
import {
  contractCenterApproveCloseOfProject,
  reviweStepCloseOfProject,
} from '../../redux/actions/closeOfProject'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import notification from '../../utils/notification'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { PROCESS_ERR_MSG, PROCESS_SUCCESS_MSG } from '../../constants/msgText'
import { Link } from 'react-router-dom'

export default function CloseProjectReviewerWidget({ schema: _schema, ...props }) {
  const history = useHistory()
  const { Column, HeaderCell, Cell } = Table
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()

  const [formSchema, setFormSchema] = useState(_schema)
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isRefash, setIsRefash] = useState()
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [note, setNote] = useState()
  const [actionType, setActionType] = useState()
  const [actionTypeMsg, setActionTypeMsg] = useState()

  const [expandedHistoties, setExpandedHistoties] = useState()

  const projectId = sessionStorage.getItem('projectId')

  const handleCallService = async (request) => {
    setIsLoading(true)
    setIsError(false)
    setIsShowConfirm(false)
    try {
      const response = await reviweStepCloseOfProject(request)

      console.log('response', response)

      if (response.success) {
        if (actionType == 1) {
          setFormSchema(response.model)
        } else {
          return history.push(`${pathname.proposal.overview.overviewCoworker}`)
        }
      } else {
        setIsError(response.message || PROCESS_ERR_MSG)
      }
    } catch (e) {
      setIsError(e?.response?.data?.errors?.message || PROCESS_ERR_MSG)
    }
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    let request = {
      projectVersionId: projectId,
      projectClosureId: formSchema.projectClosureId,
      actionType: actionType,
      note: data[formSchema.note.name],
    }

    handleCallService(request)
  }

  const onConfirm = () => {
    if (actionType == 3) {
      handleSubmit(onSubmit)()
    } else {
      handleCallService({
        projectVersionId: projectId,
        projectClosureId: formSchema.projectClosureId,
        actionType: actionType,
      })
    }
  }

  const onCancle = () => {
    setNote('')
    setIsShowConfirm(false)
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      eventKey={2}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      {isLoading && <OverlayLoader />}

      {!isRefash && (
        <>
          <p>{formSchema.detail}</p>

          {formSchema.histoties?.length > 0 && (
            <>
              {expandedHistoties && (
                <div style={{ marginBottom: 10, marginTop: 10 }}>
                  <p>
                    <b>ประวัติความเห็น</b>
                  </p>
                  <Table wordWrap autoHeight data={formSchema.histoties}>
                    <Column width={95} align="center">
                      <HeaderCell>
                        <span>ครั้งที่</span>
                      </HeaderCell>
                      <Cell>
                        {(_, index) => {
                          return index + 1
                        }}
                      </Cell>
                    </Column>
                    <Column width={350}>
                      <HeaderCell>
                        <span>ผู้ให้ความเห็น</span>
                      </HeaderCell>
                      <Cell dataKey="commenter" />
                    </Column>
                    <Column width={200}>
                      <HeaderCell>
                        <span>วันที่ให้ความเห็น</span>
                      </HeaderCell>
                      <Cell dataKey="commentDate" />
                    </Column>

                    <Column flexGrow={1} width={350}>
                      <HeaderCell>
                        <span>ความเห็น</span>
                      </HeaderCell>
                      <Cell dataKey="note" />
                    </Column>
                  </Table>
                </div>
              )}

              <Link onClick={() => setExpandedHistoties(!expandedHistoties)}>
                {expandedHistoties ? 'ซ่อนประวัติความเห็น' : 'ดูประวัติความเห็น'}
              </Link>
            </>
          )}

          {!formSchema.disabled && (
            <>
              <hr />
              {isError && (
                <Message showIcon type="error" description={isError} style={{ marginBottom: 10 }} />
              )}

              {formSchema.receiveBtn && (
                <SaveButton
                  onClick={() => {
                    setActionType(1)
                    setActionTypeMsg(formSchema.receiveBtn)
                    setIsShowConfirm(true)
                  }}
                  children={formSchema.receiveBtn}
                />
              )}
              {formSchema.passBtn && (
                <SaveButton
                  icon="check"
                  onClick={() => {
                    setActionType(2)
                    setActionTypeMsg(formSchema.passBtn)
                    setIsShowConfirm(true)
                  }}
                  children={formSchema.passBtn}
                />
              )}
              {formSchema.notPassBtn && (
                <CancelButton
                  onClick={() => {
                    setActionType(3)
                    setActionTypeMsg(formSchema.notPassBtn)
                    setIsShowConfirm(true)
                  }}
                  children={formSchema.notPassBtn}
                />
              )}
            </>
          )}
        </>
      )}

      <ConfirmWidget
        size={actionType == 3 ? 'md' : 'sm'}
        title={`ยืนยัน`}
        show={isShowConfirm}
        selfLoadingOff={true}
        detail={
          <>
            {actionType == 3 ? (
              <InputForm
                schema={formSchema.note}
                rows={5}
                componentClass="textarea"
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            ) : (
              <span>
                ยืนยันการ "{actionTypeMsg}" {formSchema.header}
              </span>
            )}
          </>
        }
        onCancle={onCancle}
        onConfirm={onConfirm}
      />
    </Panel>
  )
}
